import { Link } from "react-router-dom";
import { useLang } from "../i18n";
import { useBoot } from "../components/Layout";
import { IMG } from "../content/images";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { FinalCTA } from "../components/FinalCTA";
import { ArrowRight } from "lucide-react";

const Partners = () => {
  const { lang, t, p } = useLang();
  const boot = useBoot();
  const partners = boot?.partners || [];

  return (
    <div data-testid="partners-page">
      <Seo title={t.nav.partners} path="partenaires" />
      <PageHero eyebrow="BULA TELECOMS SA" title={t.partnersPage.heading} sub={t.partnersPage.intro}
        image={IMG.teamMeeting} crumbs={[{ label: t.nav.partners }]} />

      <section className="bg-[#F5F5F3]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-16 sm:py-24 text-center">
          <p className="text-xs font-mono tracking-widest uppercase text-[#101214]/45">{t.partnersPage.label}</p>
          {partners.length > 0 ? (
            <div className="mt-10 flex flex-wrap justify-center items-center gap-x-12 gap-y-8" data-testid="partners-grid">
              {partners.map((pt) => (
                <span key={pt.id} className="grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all">
                  {pt.logo_url
                    ? <img src={`${process.env.REACT_APP_BACKEND_URL}/api/files/${pt.logo_url}`} alt={pt.name} loading="lazy" className="h-9 w-auto object-contain" />
                    : <span className="text-xl font-black text-[#101214]/60">{pt.name}</span>}
                </span>
              ))}
            </div>
          ) : (
            <p className="mt-8 text-sm text-[#101214]/45 max-w-xl mx-auto" data-testid="partners-pending">
              {lang === "fr"
                ? "Les logos de notre écosystème seront publiés après validation écrite par les organisations concernées."
                : "Ecosystem logos will be published after written approval from the organisations concerned."}
            </p>
          )}
          <p className="mt-8 text-xs text-[#101214]/40 italic">{t.partnersPage.note}</p>
          <Reveal className="mt-10">
            <Link to={p("contact")} data-testid="become-partner-cta"
              className="inline-flex items-center gap-2 bg-[#101214] hover:bg-[#FF6600] text-white hover:text-[#08090A] font-black rounded-full px-7 py-3.5 text-sm transition-colors">
              {t.partnersPage.become} <ArrowRight size={16} />
            </Link>
          </Reveal>
        </div>
      </section>
      <FinalCTA />
    </div>
  );
};

export default Partners;
